import gql from 'graphql-tag';
import { actionGQLFields } from '../common/action.fields.js';
import { paginatedGQLFields } from '../common/paginated.fields.js';
import { postGQLFields } from '../post/posts.fields.js';
import { templateRequestGQLFields, } from '../template/templateRequest.fields.js';
import { pageGqlFields } from './page.fields.js';
import { spaceGQLFields, } from './space.fields.js';
export function createSpaceGQLQuery(fields) {
    return gql `
    mutation CreateSpace($input: CreateSpaceInput!) {
      createSpace(input: $input) {
        ${spaceGQLFields(fields)}
      }
    }
  `;
}
export function getSpacesGQLQuery(fields) {
    return gql `
    query GetSpaces(
      $after: String
      $before: String
      $collectionId: String
      $limit: Int!
      $memberId: ID
      $offset: Int
      $orderBy: SpaceListOrderByEnum
      $query: String
      $reverse: Boolean
      $type: [SpaceType!]
    ) {
      spaces(
        after: $after
        before: $before
        collectionId: $collectionId
        limit: $limit
        memberId: $memberId
        offset: $offset
        orderBy: $orderBy
        query: $query
        reverse: $reverse
        type: $type
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${spaceGQLFields(fields)}
          }
        }
        nodes {
          ${spaceGQLFields(fields)}
        }
      }
    }
  `;
}
export function getSpacesByIdsGQLQuery(fields) {
    return gql `
    query GetSpacesByIds($ids: [ID!]!) {
      spacesByIds(ids: $ids) {
        ${spaceGQLFields(fields)}
      }
    }
  `;
}
export function getSpacesBySlugsGQLQuery(fields) {
    return gql `
    query GetSpacesBySlugs($slugs: [String!]!) {
      spacesBySlugs(slugs: $slugs) {
        ${spaceGQLFields(fields)}
      }
    }
  `;
}
export function getSpaceGQLQuery(fields) {
    return gql `
    query GetSpace($id: ID, $slug: ID, $path: String) {
      space(id: $id, slug: $slug, path: $path) {
        ${spaceGQLFields(fields)}
      }
    }
  `;
}
export function getPageGqlQuery(fields) {
    return gql `
    query page($path: String!) {
      page(path:$path) {
        ${pageGqlFields(fields)}
      }
    }
  `;
}
export const organizeSpacesInCollectionGQLMutation = (fields) => gql `
  mutation OrganizeSpacesInCollection(
    $collectionId: String!
    $spaceIds: [String!]!
  ) {
    organizeSpacesInCollection(
      collectionId: $collectionId
      spaceIds: $spaceIds
    ) {
      ${actionGQLFields(fields)}
    }
  }
`;
export const updateSpaceGQLMutation = (fields) => gql `
    mutation updateSpace($id: ID!, $input: UpdateSpaceInput!) {
      updateSpace(id: $id input: $input) {
        ${spaceGQLFields(fields)}
      }
    }
  `;
export const joinSpaceGQLMutation = () => gql `
  mutation joinSpace($spaceId: ID!) {
    joinSpace(spaceId: $spaceId) {
      status
      __typename
    }
  }
`;
export const leaveSpaceGQLMutation = () => gql `
  mutation leaveSpace($spaceId: ID!) {
    leaveSpace(spaceId: $spaceId) {
      status
      __typename
    }
  }
`;
export const getSpacePinnedPostGQLQuery = (fields) => gql `
  query GetSpacePinnedPosts($spaceId: ID!) {
    spacePinnedPosts(spaceId: $spaceId) {
      ${postGQLFields(fields)}
    }
  }
`;
export const getSpaceTaggedPostsGQLQuery = (fields) => gql `
  query GetPostsByTag(
    $spaceId: ID
    $tagId: ID
    $tagSlug: String
    $after: String
    $before: String
    $limit: Int!
    $offset: Int
    $reverse: Boolean
  ) {
    tagPosts(
      spaceId: $spaceId
      tagId: $tagId
      tagSlug: $tagSlug
      after: $after
      before: $before
      limit: $limit
      offset: $offset
      reverse: $reverse
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          ${postGQLFields(fields)}
        }
      }
      nodes {
        ${postGQLFields(fields)}
      }
    }
  }
`;
export const updateSpaceHighlightedTagsMutation = () => gql `
  mutation updateSpaceHighlightedTags(
    $input: UpdateHighlightedTags!
    $spaceId: ID!
  ) {
    updateSpaceHighlightedTags(input: $input, spaceId: $spaceId) {
      status
      __typename
    }
  }
`;
export const exploreSpacesGQLQuery = (fields) => gql `
  query ExploreSpaces(
    $after: String
    $before: String
    $collectionId: String
    $limit: Int!
    $offset: Int
    $reverse: Boolean
  ) {
    exploreSpaces(
      after: $after
      before: $before
      collectionId: $collectionId
      limit: $limit
      offset: $offset
      reverse: $reverse
    ) {
      ${paginatedGQLFields(fields, spaceGQLFields)}
    }
  }
`;
export const deleteSpaceGQLMutation = (fields) => gql `
  mutation DeleteSpace($id: ID!) {
    deleteSpace(id: $id) {
      ${actionGQLFields(fields)}
    }
  }
`;
export function createSpaceFromTemplateGQLMutation(fields) {
    return gql `
    mutation createSpaceFromTemplate($input: CreateSpaceInput!, $style: String, $templateId: String!) {
      createSpaceFromTemplate(input: $input, style: $style, templateId: $templateId) {
        ${templateRequestGQLFields(fields)}
      }
    }
  `;
}
export const readSpaceGQLMutation = () => gql `
  mutation ReadSpace($date: DateTime!, $spaceId: String!) {
    readSpace(date: $date, spaceId: $spaceId) {
      status
    }
  }
`;
export const closeSpaceGQLMutation = () => gql `
  mutation CloseSpace($spaceId: ID!) {
    closeSpace(spaceId: $spaceId) {
      status
    }
  }
`;
//# sourceMappingURL=spaces.gql.js.map